module.exports = __webpack_public_path__ + "img/emma.cf7d7083.png";